module.exports = __webpack_public_path__ + "static/media/location_on_not_selected.1ab8c171.svg";